import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';

class InstitutionTQRegistrationList extends Component {

  constructor(props){
    super(props);
    this.state={
      registeredTQList: [],
      itemsPerPage: 200,
      totalCount: '',
    }
  }

  componentDidMount() {

    return api.getInstitutionTQList(this.props.user.accessToken,1,this.state.itemsPerPage)
    .then((result) => {
      console.log(result)
      if(result.status === 'success'){
      this.setState({registeredTQList: result.data,totalCount: result.count})
      }
    })
  }

  fetchRegisteredTQDetails = (pageNo) => {
    api.getInstitutionTQList(this.props.user.accessToken, pageNo, this.state.itemsPerPage)
    .then((result) => {
      console.log(result)
      if(result.status === 'success'){
      this.setState({registeredTQList: result.data,totalCount: result.count})
      }
    })
  }

  render() {
    let displayComponent;
    let paginationKey = this.state.totalCount
    if(this.state.registeredTQList) {
      displayComponent = (
        <tbody>
          {this.state.registeredTQList.map((registration) => (
            <tr>
              <td>{registration.user_name}</td>
              <td>{registration.phone}</td>
              <td>{registration.email}</td>
              <td>{registration.tq_test_track_name}</td>
              <td>{registration.coupon_code_name}</td>
              <td>{registration.institution_name}</td>
              <td>{registration.created_at.split('T')[0]}</td>
            </tr>
          ))}
        </tbody>
      )
    }
    return (
      <div>
        <Grid>
          <GridCell span="12">
            <Typography use="headline6">TQ Registration List</Typography>
            <p>Please direct the candidate to enter the invite code on this link: <a href="https://centa.proaptitude.com/" target="_blank">https://centa.proaptitude.com/</a></p>
          </GridCell>
          <GridCell span="12">
              <table>
                <th>User Name</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Test Track Name</th>
                <th>Coupon Name</th>
                <th>Institution</th>
                <th>Registered Date</th>
                {displayComponent}
              </table>
            </GridCell>
        </Grid>
        <div key={paginationKey}>
          <PaginationComponent totalItems = {this.state.totalCount}
            itemsPerPage = {this.state.itemsPerPage} 
            onHandleItemsFetch = {this.fetchRegisteredTQDetails} />
        </div>
      </div>
    )
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionTQRegistrationList);


// WEBPACK FOOTER //
// ./src/views/PartialTQ/InstitutionTQRegistrationList.jsx